import HelpTextsDataTable from "../../../components/dataTable/tables/HelpTextsDataTable";

function HelpTextsPageView() {
  return <HelpTextsDataTable />;
}

export default HelpTextsPageView;
